import type { CustomEventTriggerState, RuntimeContext } from "./types.js";

/**
 * Returns persistent custom-event trigger state for the given instance key.
 */
export function getOrCreateCustomEventTriggerState(
  ctx: RuntimeContext,
  stateKey: string,
): CustomEventTriggerState {
  let map = ctx.__customEventTriggerStateByKey;

  if (!map) {
    map = new Map();
    ctx.__customEventTriggerStateByKey = map;
  }

  let state = map.get(stateKey);

  if (!state) {
    state = { onLoadDone: false };
    map.set(stateKey, state);
  }

  return state;
}
